import type { FaireProductEntity } from "../../entity_types/product";

export const p_umw3dew5js: FaireProductEntity = {
  token: "p_umw3dew5js",
  type: "product",
  name: "All Over Bows Knit Sweater - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/6e667a6c255fe084926045595cfb220b456f9c904f482ed1536794d0850acd6f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66a47a99713dc44e1ba9ce230bad548f74b18e35d3a61a5f884a0df8bf9ef49e.jpeg",
    "https://cdn.faire.com/fastly/c1fe228f8dabcbe8680b75ee529f78089368fdf0abf1d989eb3e4caf19bf4ab0.jpeg",
    "https://cdn.faire.com/fastly/ddc4ff0c5e78ca44c51a59e87d9830ed26f386720fa033ca1e5e0f89b35c2734.jpeg",
    "https://cdn.faire.com/fastly/876010b409904460da68b5de4c1210167ca847d554cee1d4e80ca083311d0b10.jpeg",
    "https://cdn.faire.com/fastly/14effe73eb36a8803f902eac31fa5ddaa7fdbb0f3a0d2cd4e16dc7a4fc97d6f3.jpeg",
    "https://cdn.faire.com/fastly/ca8ac8ea45bb1843798026ece75a2698edd8ff52c61f2ea377529a02f89cbe1f.jpeg",
  ],
  priceDollars: 32,
  description:
    "The All Over Bows Knit Sweater is a cute and trendy sweater inspired by the latest bow trend!\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n•Sweater Color: Blush Pink\n•Embroidery Color: Ivory\n•Material: 100% Acrylic\n•Fit: Moderately oversized\n•Care: Hand wash only, do not iron, tumble dry, bleach or dry clean\n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 64,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:22:15.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
